import * as React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { DefaultFontStack } from "../typography/typography";
import Link from "../link/link";

const Root = styled.div`
  ${DefaultFontStack}
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.cloud};
  height: 100%;
  padding: 10px;
  color: ${({ theme }) => theme.colors.awesome};
  font-weight: 600;
  gap: 10px;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.silver};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Button = styled.button`
  all: unset;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`;

const StyledLink = styled(Link)`
  all: unset;
  ${DefaultFontStack}
  cursor: pointer;
  font-weight: 600;
`;

function DrawerItemsList(props) {
  const { items, onActiveItemChange, onClose } = props;

  const onItemClickHandler = (item) => {
    return () => {
      onActiveItemChange(item);
    };
  };

  return (
    <Root data-component-name="drawer-items-list">
      {items.map((item) => (
        <Item key={item.text}>
          {item.url !== undefined ? (
            <StyledLink onClick={onClose} url={item.url}>
              {item.text}
            </StyledLink>
          ) : (
            <Button onClick={onItemClickHandler(item)}>
              <span>{item.text}</span>
              <FontAwesomeIcon
                icon={faChevronRight}
                style={{ height: 20, width: 20 }}
              />
            </Button>
          )}
          <Divider />
        </Item>
      ))}
    </Root>
  );
}

export default DrawerItemsList;
